import { far } from '@awesome.me/kit-b4fd369ea4/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Checkbox, ClickAwayListener, IconButton, InputAdornment, List, ListItem, Paper, Popper } from '@mui/material';
import { useState } from 'react';

export const PeriodicityButton = ({
  periodicities,
  selectedPeriodicities,
  onPeriodicityChange,
  closeFilterDropdown,
  anchorRef,
  dimDisplayName,
}) => {
  const [open, setOpen] = useState(false);

  const handleButtonClick = (event) => {
    event.stopPropagation();
    closeFilterDropdown();
    setOpen((prev) => !prev);
  };

  const handleCheckboxClick = (clickedPeriodicity) => {
    const isSelected = selectedPeriodicities.includes(clickedPeriodicity);

    let newSelectedPeriodicities;
    if (isSelected) {
      newSelectedPeriodicities = selectedPeriodicities.filter((periodicity) => periodicity !== clickedPeriodicity);
    } else {
      // add it, but keep the order defined by `periodicities`
      newSelectedPeriodicities = periodicities.filter(
        (periodicity) => selectedPeriodicities.includes(periodicity) || periodicity === clickedPeriodicity,
      );
    }

    onPeriodicityChange(newSelectedPeriodicities);
  };

  const periodicityCodeToDisplayName = {
    LIFETIME: 'Lifetime',
    MON: 'Month',
    QTR: 'Quarter',
    YEAR: 'Year',
  };

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <div style={{ display: 'inline-block' }}>
        <InputAdornment>
          <IconButton ref={anchorRef} onClick={handleButtonClick}>
            <FontAwesomeIcon icon={far.faCalendar} />
          </IconButton>
        </InputAdornment>

        <Popper disablePortal open={open} anchorEl={anchorRef.current} placement="bottom-end" style={{ zIndex: 1300 }}>
          <Paper onClick={(event) => event.stopPropagation()} sx={{ pr: 2 }}>
            <List>
              {periodicities.map((periodicity) => (
                <ListItem key={periodicity}>
                  <Checkbox
                    checked={selectedPeriodicities.includes(periodicity)}
                    onClick={() => handleCheckboxClick(periodicity)}
                  />
                  {periodicityCodeToDisplayName[periodicity]}
                </ListItem>
              ))}
            </List>
          </Paper>
        </Popper>
      </div>
    </ClickAwayListener>
  );
};
